export const MuiFormControl = {
    defaultProps: {
        variant: 'outlined',
        size: 'small'
    }
};

//# sourceMappingURL=form-control.js.map